import { render, staticRenderFns } from "./Perfect.vue?vue&type=template&id=319ccd1a&scoped=true&"
import script from "./Perfect.vue?vue&type=script&lang=js&"
export * from "./Perfect.vue?vue&type=script&lang=js&"
import style0 from "./Perfect.vue?vue&type=style&index=0&id=319ccd1a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319ccd1a",
  null
  
)

export default component.exports